import H from 'history'

/**
 * Only show discount for related topic on breach screen
 */
export function showBreachForTopic(
    location: H.Location,
    breachEnabled: boolean,
    topic: string,
    subTopic?: string,
    fuzzyMatchSubTopicOnly?: boolean,
    partMatchSubTopicOnly?: boolean,
) {
    const path = location.pathname.split('/')
    if (!subTopic) {
        return breachEnabled && path.length > 0 ? path[1] === topic : false
    }
    if (!fuzzyMatchSubTopicOnly) {
        return breachEnabled && path.length > 0
            ? path[1] === topic && path[2] === subTopic
            : false
    }
    //TODO: Refactor this function to take in dynamic url paths
    if (partMatchSubTopicOnly) {
        return breachEnabled && path.length > 1 ? location.pathname.includes(subTopic) : false
    }
    return breachEnabled && path.length > 1 ? path[2].includes(subTopic) : false
}

export function showBreachDiscount(
    location: H.Location,
    featureEnabled: boolean,
) {
    return featureEnabled && location.pathname.length > 0
        ? location.pathname.includes('lisa-govan')
        : false
}
